import { useMutation } from "@tanstack/react-query";
import { UpdateEventParams, updateEvent } from "supabase/events";
import { queryClient } from "utils";

export const useUpdateEvent = (onSuccess: () => any) => {
  const mutation = useMutation({
    mutationFn: (event: UpdateEventParams) => {
      return updateEvent(event);
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["events"],
      });
      queryClient.invalidateQueries({
        queryKey: ["event", variables.uid],
      });

      onSuccess();
    },
  });

  return mutation;
};
